import type { MediaModeOptions } from './types/internal/media-mode';

export const mediaModeOptionsAudio: MediaModeOptions = {
  mode: 'audio',
  hasFullscreen: false,
  hasMediaInfo: true,
  hasPreviewNextMedium: false,
  hasPrimeControls: false,
  hasSeekButtonsInControls: true,
  shouldHideControlsOnSessionEnd: false,
  shouldHideContentLayerOnClick: false,
  shouldHideContentLayerOnIdle: false,
};

export const mediaModeOptionsVideo: MediaModeOptions = {
  mode: 'video',
  hasFullscreen: true,
  hasMediaInfo: false,
  hasPreviewNextMedium: true,
  hasPrimeControls: true,
  hasSeekButtonsInControls: false,
  shouldHideControlsOnSessionEnd: true,
  shouldHideContentLayerOnClick: true,
  shouldHideContentLayerOnIdle: true,
};
